




















import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import { uniqueId } from "@apphq/utils";

/**
 * Select an item with the browser’s select input.
 */
@Component
export default class ListSelectInput<T> extends Vue {
  @Model("input", { default: null }) value!: T | null;

  /** Available list items to select from */
  @Prop({
    required: true,
    validator: (options: any) =>
      options != null && typeof options[Symbol.iterator] === "function"
  })
  options!: Iterable<T>;
  /** Callback that returns a name for each list item. */
  @Prop({ type: Function, default: (item: T) => String(item) })
  getName!: (option: T) => string;
  /** Label above the input */
  @Prop({ type: String, default: "" }) label!: string;
  /** Number of lines to display */
  @Prop({ type: Number, required: false }) size?: number;
  /** Disable the input */
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  selection: T | null = this.value;

  get inputId() {
    return "select-" + uniqueId();
  }

  get selectSize() {
    return this.size || Math.max(2, Array.from(this.options).length);
  }

  @Watch("value") onValueUpdate(value: T | null) {
    this.selection = value;
  }

  @Watch("selection") onInput(value: T | null) {
    this.$emit("input", value);
  }
}
